export default __webpack_public_path__ + "bc0ba85feb020847a20dc5708cd595df.png";